module.exports = __webpack_public_path__ + "static/img/default.5b26b2c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/payment-icons/min/flat/default.svg
// module id = 6L8d
// module chunks = 3